import { RunContextApp } from "framework/RCApp";
import { UserRoleInfo } from "types/apis/sessionInterfaces";

export enum USER_ROLE {
  TPM           = 'TPM',
  CSM           = 'CSM',
  PM            = 'PM',
  UTILITY       = 'UTILITY',
  SUPER_ADMIN   = 'SUPER_ADMIN',
  PE            = 'PE',
  DELIVERY      = 'DELIVERY',
  FULL_ACCESS   = 'FULL_ACCESS'
}

export class PermissionsManager {
  private userRoleInfo!: UserRoleInfo;

  constructor(private rc: RunContextApp) {}

  setUserRoleInfo(userRoleInfo: UserRoleInfo) {
    this.userRoleInfo = userRoleInfo;
  }

  getUserRole(): USER_ROLE {
    return this.userRoleInfo.role.name as USER_ROLE;
  }

  getUserRoleDescription(): string {
    return this.userRoleInfo?.role?.description;
  }

  // Helper method to safely check permissions
  private hasPermission(permission: string): boolean {
    return this.userRoleInfo?.permissions?.includes(permission) || false;
  }

  canFeatureWorkflowFind(): boolean {
    return this.userRoleInfo.permissions.includes('api::feature-workflow.feature-workflow.find');
  }

  canSystemNodeFind(): boolean {
    return this.userRoleInfo.permissions.includes('api::system-node.system-node.find');
  }

  canSystemNodePositionFind(): boolean {
    return this.userRoleInfo.permissions.includes('api::system-node-position.system-node-position.find');
  }

  canUtilityCreate(): boolean {
    return this.userRoleInfo.permissions.includes('api::utility.utility-internal-apis.createUtility');
  }

  canUtilityApplianceProfileUpdate(): boolean {
    return this.userRoleInfo.permissions.includes('api::utility-appliance-profile.utility-appliance-profile-internal-apis.updateApplianceProfile');
  }

  canUtilityHomeProfileUpdate(): boolean {
    return this.userRoleInfo.permissions.includes('api::utility-home-profile.utility-home-profile-internal-apis.updateHomeProfile');
  }

  canRecommendationCreate(): boolean {
    return this.userRoleInfo.permissions.includes('api::recommendation.reco-internal-apis.createReco');
  }

  canRecommendationPublishAll(): boolean {
    return this.userRoleInfo.permissions.includes('api::recommendation.reco-internal-apis.publishAll');
  }

  canRecoScoreUpdate(): boolean {
    return this.userRoleInfo.permissions.includes('api::utility-reco-score.utility-reco-score-internal-apis.updateRecoScore');
  }

  canViewRecommendationExclusions(): boolean {
    return this.getUserRole() !== USER_ROLE.UTILITY;
  }
  
}
